function parseBooleanEnv(value: string | undefined): boolean | undefined {
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim().toLowerCase();
  if (!normalized) return undefined;
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  return undefined;
}

function resolvePrivateBooleanFlag(envKeys: string | string[], fallback: boolean): boolean {
  for (const key of Array.isArray(envKeys) ? envKeys : [envKeys]) {
    const privateFlag = parseBooleanEnv(process.env[key]);
    if (privateFlag !== undefined) return privateFlag;
  }
  return fallback;
}

export function isAdsModuleEnabledServer(): boolean {
  return parseBooleanEnv(process.env.NEXT_PUBLIC_ADS_MODULE_ENABLED) ?? false;
}

export function isAdsModuleEnabledClient(): boolean {
  return parseBooleanEnv(process.env.NEXT_PUBLIC_ADS_MODULE_ENABLED) ?? false;
}

export function isAdsMutationsEnabledServer(): boolean {
  return resolvePrivateBooleanFlag(
    ['OPENAI_ADS_MUTATIONS_ENABLED', 'ENABLE_OPENAI_ADS_MUTATIONS'],
    false
  );
}

export function isAdsMutationsEnabledClient(): boolean {
  return parseBooleanEnv(process.env.NEXT_PUBLIC_OPENAI_ADS_MUTATIONS_ENABLED) ?? false;
}

export function isAdsActivationEnabledServer(): boolean {
  return resolvePrivateBooleanFlag(
    ['ADS_ACTIVATION_ENABLED', 'ENABLE_OPENAI_ADS_ACTIVATION'],
    false
  );
}

export function isAdsActivationEnabledClient(): boolean {
  return (
    parseBooleanEnv(process.env.NEXT_PUBLIC_ADS_ACTIVATION_ENABLED) ??
    parseBooleanEnv(process.env.NEXT_PUBLIC_OPENAI_ADS_ACTIVATION_ENABLED) ??
    false
  );
}
